import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, NgForm, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AmbassadorEducationalQualification } from 'projects/admin/src/app/features/user-management/consumer-ambassadors/models/AmbassadorEducationalQualification';
import { AmbassadorsProfileService } from 'projects/admin/src/app/features/user-management/consumer-ambassadors/services/connect/ambassadors-profile.service';
import { ConnectLookupsService } from 'projects/admin/src/app/features/user-management/consumer-ambassadors/services/connect/connectLookups.service';
import { DirtyComponent } from 'projects/shared/src/helpers/CanDeactivate/dirty-component';
import { Lookup } from 'projects/shared/src/models/lookup';
import Swal from 'sweetalert2';
export interface DialogData {
  record: AmbassadorEducationalQualification;
}
@Component({
  selector: 'app-educational-qualifications-form',
  standalone: false,
  templateUrl: './educational-qualifications-form.component.html'
})
export class EducationalQualificationsFormComponent extends DirtyComponent implements OnInit {
  loading = false
  override formGroup: FormGroup = new FormGroup({});
  degreesList: Lookup[] = []
  monthsList: Lookup[] = []
  yearsList: any[] = []
  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    override dialogRef: MatDialogRef<EducationalQualificationsFormComponent>,
    private service: AmbassadorsProfileService,
    private lookupsService: ConnectLookupsService,
    translate: TranslateService
  ) {
    super(translate)
  }
  ngOnInit(): void {
    this.getEducationalDegrees()
    this.getMonths()
    this.generateYears()
    this.initForm()
    if (this.data.record) {
      this.bindData(this.data.record)
    }
    this.formGroup.get('currentlyStudying')?.valueChanges.subscribe(value => {
      this.updateEndDateState(value);
    });
  }

  bindData(record: AmbassadorEducationalQualification) {

    this.formGroup.patchValue(
      record, { emitEvent: true }
    )
    this.updateEndDateState(record.currentlyStudying);
  }

  getEducationalDegrees() {
    this.lookupsService.getEducationalDegrees().subscribe((res: any) => {
      this.degreesList = res
    }, (err: any) => {

    })
  }

  getMonths() {
    this.lookupsService.getMonths().subscribe((res: any) => {
      this.monthsList = res
    }, (err: any) => {

    })
  }

  generateYears() {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 50;

    this.yearsList = Array.from({ length: 51 }, (_, i) => {
      const year = currentYear - i;
      return { id: year, name: year.toString() };
    });
  }



  initForm() {
    this.formGroup = this.fb.group({
      institutionName: ['', {
        validators: [
          Validators.required,
          // Validators.pattern('^(?=.*[a-zA-Z])[a-zA-Z0-9 _-]+$')
        ]
      }],

      degreeId: [null, [Validators.required]],
      fieldOfStudy: ['', [Validators.required]],
      startDate: this.fb.group({
        month: ['', [Validators.required]],
        year: ['', [Validators.required]]
      }),

      endDate: this.fb.group({
        month: ['', [Validators.required]],
        year: ['', [Validators.required]]
      }),
      currentlyStudying: [false]
    }, { validators: this.dateRangeValidator });
  }


  handelEndDateValue(event: any) {
    const endDateGroup = this.formGroup.get('endDate');
    const monthControl = endDateGroup?.get('month');
    const yearControl = endDateGroup?.get('year');

    if (event.checked) {
      monthControl?.setValue(null);
      yearControl?.setValue(null);

      monthControl?.clearValidators();
      yearControl?.clearValidators();
    } else {
      monthControl?.setValidators([Validators.required]);
      yearControl?.setValidators([Validators.required]);
    }

    monthControl?.updateValueAndValidity();
    yearControl?.updateValueAndValidity();
  }

  dateRangeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const startGroup = control.get('startDate');
    const endGroup = control.get('endDate');
    const currentlyStudying = control.get('currentlyStudying')?.value;

    if (!startGroup || !endGroup || currentlyStudying) {
      return null;
    }

    const startYear = +startGroup.get('year')?.value;
    const startMonthId = +startGroup.get('month')?.value;
    const endYear = +endGroup.get('year')?.value;
    const endMonthId = +endGroup.get('month')?.value;

    if (!startYear || !endYear || !startMonthId || !endMonthId) {
      return null;
    }


    const startDate = new Date(startYear, startMonthId - 1);
    const endDate = new Date(endYear, endMonthId - 1);

    return endDate < startDate ? { dateRangeInvalid: true } : null;
  }


  updateEndDateState(iscurrentlyWorking: boolean) {
    const endDateGroup = this.formGroup.get('endDate');
    if (iscurrentlyWorking) {
      endDateGroup?.disable();
    } else {
      endDateGroup?.enable();
    }
  }



  saveRecord() {
    if (this.formGroup.valid) {
      this.loading = true
      let formControls = this.formGroup.value
      if (this.data.record) formControls.id = this.data.record.id
      this.service.AddOrUpdateAmbassadorEducationalQualification(formControls).subscribe(() => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: this.data.record ? this.translate.instant('swalMsg.updatedsuccessfully') : this.translate.instant('swalMsg.savedsuccessfully'),
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        this.dialogRef.close(true)
      }, error => {
        this.loading = false;

        if (error && error.detail) {
          Swal.fire({
            title: this.translate.instant('swalMsg.Failed'),
            text: error.detail,
            icon: 'error',
            confirmButtonText: this.translate.instant('swalMsg.Ok')
          });
        }
      });

    }
  }

  hasError(controlName: string, errorName: string, groupName?: string): boolean {
    const path = groupName ? `${groupName}.${controlName}` : controlName;
    const control = this.formGroup.get(path);

    return !!(control && control.hasError(errorName) && (control.touched || this.form?.submitted));
  }
}


